import { ErrorHandlerName, IErrorHandler } from "../Libs/xhr/ErrorHandler";
import { Constants } from "./Constants";
import { CustomErrorHandler } from "./Errors/CustomErrorHandler";
import { initializeApiClient } from "./Services/Api/ApiService";
import { I18nService, I18nServiceName, II18nService } from "./Services/I18n/I18nService";
import { LogService } from "./Services/LogService";
import { IoC } from "./Services/ServicesContainer";
import { WorkersServiceName, IWorkersService, WorkersService } from "./Services/Workers/WorkersService";
import { WorkersDataService, WorkersDataServiceName, IWorkersDataService } from "./DataServices/WorkersDataService";

export abstract class CoreBootstrapper {
  protected initializeCore = (): void => {
    const appErrorHandler = IoC.get<IErrorHandler>(ErrorHandlerName);

    //* Setup Api client
    const timeout = 1000 * 60; //* 1 minute;
    initializeApiClient(Constants.getRoot(), appErrorHandler, timeout);
  };

  protected initializeCoreServices = (): void => {
    //* Create and bind I18nService
    const i18nService: II18nService = new I18nService();
    IoC.bind<II18nService>(I18nServiceName, i18nService);

    //* Create and bind App ErrorHandler
    IoC.bind<IErrorHandler>(ErrorHandlerName, new CustomErrorHandler(i18nService, new LogService()));

    //* Workers Services
    IoC.bind<IWorkersDataService>(WorkersDataServiceName, new WorkersDataService());
    IoC.bind<IWorkersService>(WorkersServiceName, new WorkersService());
  };
}
